
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Clipboard } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';

interface LinkShareProps {
  referralUrl: string | null;
}

export function LinkShare({ referralUrl }: LinkShareProps) {
  const { toast } = useToast();
  const [isCopying, setIsCopying] = useState(false);
  
  const handleCopyLink = async () => {
    if (!referralUrl) {
      toast({
        title: "No link available",
        description: "Please wait while we generate your referral link.",
        variant: "destructive"
      });
      return;
    }
    
    setIsCopying(true);
    try {
      await navigator.clipboard.writeText(referralUrl);
      toast({
        title: "Link copied to clipboard",
        description: "Your referral link has been copied to your clipboard."
      });
    } catch (err) {
      toast({
        title: "Failed to copy",
        description: "Could not copy to clipboard. Please try again.",
        variant: "destructive"
      });
    } finally {
      setIsCopying(false);
    }
  };
  
  return (
    <div className="space-y-4">
      <p className="text-sm">Your unique referral link:</p>
      <div className="flex flex-col gap-2">
        <Input value={referralUrl || ''} readOnly className="font-mono text-sm" />
        <Button
          onClick={handleCopyLink}
          disabled={isCopying || !referralUrl}
        >
          <Clipboard className="h-4 w-4 mr-2" />
          {isCopying ? 'Copying...' : 'Copy Link'}
        </Button>
      </div>
    </div>
  );
}
